import {
  asiakas_cacheName,
  cache_clear,
  cache_read,
  cache_write,
} from "src/components/js/CacheFunctions";
import { checkResponse } from "src/components/js/statics1";

export async function stat_getStat1(year, month, ownerAsiakasId, token) {
  // leave year and month null to get all data
  const fullUrl =
    import.meta.env.VITE_SERVER_URL + `/api/stat/getStat1/${year}/${month}/${ownerAsiakasId}`;
  const response = await fetch(fullUrl, {
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "statClass:getStat1");
  cResponse.data.sort((a, b) => {
    if (a.year === b.year) return a.month - b.month;
    return a.year - b.year;
  });
  return cResponse.data;
}
export async function stat_getStat2(pumppuAsiakasId, betoniAsiakasId, token) {
  const fullUrl =
    import.meta.env.VITE_SERVER_URL + `/api/stat/getStat2/${pumppuAsiakasId}/${betoniAsiakasId}`;
  const response = await fetch(fullUrl, {
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "statClass:getStat2");
  cResponse.data.sort((a, b) => {
    if (a.year === b.year) return a.month - b.month;
    return a.year - b.year;
  });
  return cResponse.data;
}
export async function stat_getStat3(pumppuAsiakasId, betoniAsiakasId, ownerAsiakasId, token) {
  const fullUrl =
    import.meta.env.VITE_SERVER_URL +
    `/api/stat/getStat3/${pumppuAsiakasId}/${betoniAsiakasId}/${ownerAsiakasId}`;
  const response = await fetch(fullUrl, {
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "statClass:getStat3");
  cResponse.data.sort((a, b) => {
    if (a.year === b.year) return a.month - b.month;
    return a.year - b.year;
  });
  return cResponse.data;
}

export async function stat_getStat2Weighted(ownerAsiakasId, token, useCache = true) {
  const fullUrl = import.meta.env.VITE_SERVER_URL + `/api/stat/getStat2Weighted/${ownerAsiakasId}`;
  if (useCache) {
    const c = cache_read("statCache", fullUrl);
    if (c) return c;
  }
  const response = await fetch(fullUrl, {
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "statClass:getStat2Weighted");
  if (!cResponse.success) return false;
  cache_write("statCache", fullUrl, cResponse.data);
  return cResponse.data;
}
export async function stat_recalcStat1(year, month, ownerAsiakasId, token) {
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/stat/recalcStat1";
  cache_clear("statCache");
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ year: year, month: month, ownerAsiakasId: ownerAsiakasId }),
  };
  const response = await fetch(fullUrl, requestOptions);
  return response.ok;
}
export async function stat_getLasku1(laskuttajaAsiakasId, token) {
  const fullUrl =
    import.meta.env.VITE_SERVER_URL + `/api/stat/getStat/lasku/1/${laskuttajaAsiakasId}`;
  const response = await fetch(fullUrl, {
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "statClass:getLasku1");
  return cResponse.data;
}

export async function stat_addRowToStat2(
  year,
  month,
  ownerAsiakasId,
  sourceAsiakasId,
  pumppuAsiakasId,
  betoniAsiakasId,
  token
) {
  cache_clear("statCache");
  cache_clear(asiakas_cacheName);
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/stat/stat2/addRow";
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      year: year,
      month: month,
      ownerAsiakasId: ownerAsiakasId,
      sourceAsiakasId: sourceAsiakasId,
      pumppuAsiakasId: pumppuAsiakasId,
      betoniAsiakasId: betoniAsiakasId,
    }),
  };
  const response = await fetch(fullUrl, requestOptions);
  return response.ok;
}

export async function stat_deleteRowFromStat2(stat2Id, token) {
  cache_clear("statCache");
  cache_clear(asiakas_cacheName);
  const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/stat/stat2/deleteRow/" + stat2Id;
  const requestOptions = {
    method: "DELETE",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ stat2Id: stat2Id }),
  };
  const response = await fetch(fullUrl, requestOptions);
  return response.ok;
}
